import { Navigate, useParams } from "react-router-dom-v5-compat";

import { getPriceListDetailsUrl, getPriceListHomeUrl } from "./routes";

export const PriceListRedirect = () => {
  const { uuid } = useParams<{ uuid: string }>();

  return <Navigate to={uuid ? getPriceListDetailsUrl(uuid) : getPriceListHomeUrl()} replace />;
};
